import { documentAnalyzerSDK } from './documentAnalyzerSDK'
import { downloadUserDocumentsSDK } from './downloadUserDocumentsSDK'
import { lawyerManagerSDK } from './lawyerManagerSDK'
import { serviceManagerSDK } from './serviceManagerSDK'

export default {
  serviceManager: serviceManagerSDK(),
  documentAnalyzer: documentAnalyzerSDK(),
  lawyerManager: lawyerManagerSDK(),
  downloadUserDocuments: downloadUserDocumentsSDK()
}
